import { Dialog } from 'primereact/dialog'
import React from 'react'
import { SelectAbrogationDialogProps } from '../../../types/inbound'
import { Ripple } from 'primereact/ripple'
import PrimeReact from 'primereact/api'
import { tokens } from 'locales/tokens'
import { useTranslation } from 'react-i18next'

const SelectAbrogationDialog = (props: SelectAbrogationDialogProps) => {
    const { t } = useTranslation()
    PrimeReact.ripple = true

    const onClickSelectAbrogation = (tkbckAbrgCd: string) => {
        props.onSelect && props.onSelect(tkbckAbrgCd)
    }

    return (
        <Dialog
            headerClassName="p-1"
            headerStyle={{ background: '#F8F9FA' }}
            contentStyle={{ paddingLeft: '1rem', paddingRight: '1rem', background: '#F8F9FA' }}
            visible={props.visible}
            onHide={() => props.onHide && props.onHide()}
            closable={false}
            contentClassName="pb-0"
        >
            <div className="grid justify-content-center">
                <div
                    className="col-12 flex border-bottom-1 p-4 p-ripple"
                    style={{ borderColor: '#64748B' }}
                    onClick={() => onClickSelectAbrogation('SP')}
                >
                    <span className="font-bold w-full text-left">{t(tokens.common.shelf_over_limit)}</span>
                    <Ripple />
                </div>
                <div
                    className="col-12 flex border-bottom-1 p-4 p-ripple"
                    style={{ borderColor: '#64748B' }}
                    onClick={() => onClickSelectAbrogation('BK')}
                >
                    <span className="font-bold w-full text-left">{t(tokens.common.damaged_goods)}</span>
                    <Ripple />
                </div>
                <div
                    className="col-12 flex font-bold w-full p-4 p-ripple"
                    style={{ borderColor: '#64748B' }}
                    onClick={() => onClickSelectAbrogation('BD')}
                >
                    <span className="font-bold w-full text-left">{t(tokens.common.defected_goods)}</span>
                    <Ripple />
                </div>
            </div>
        </Dialog>
    )
}

export default SelectAbrogationDialog
